module.exports = __webpack_public_path__ + "img/praxis-lambrette-wortmarke.b9ec970b.svg";